import { createGenericDebouncableDataLoader } from '@atlassian/jira-jql-builder-basic-picker/src/common/utils/debouncer.tsx';

// eslint-disable-next-line @atlassian/eng-health/no-barrel-files/disallow-reexports
export { components } from './ui';
// LDR: https://hello.atlassian.net/wiki/spaces/JFE/pages/2625316871/LDR+Maximum+number+of+columns+to+allow+in+NIN+in+M7.3
export const MAX_COLUMNS = 500;
export const createDebouncedColumnLoader = createGenericDebouncableDataLoader;

export const REMOVE_COLUMNS = 'REMOVE_COLUMNS';
export const ADD_COLUMNS = 'ADD_COLUMNS';
